import * as countryMarket from '../../controllers/CountryMarketController/CountryMarketState';
import * as taxonomies from '../../controllers/TaxonomyController/TaxonomyState';
import * as briefing from '../../features/Briefing/BriefingState';
import * as customerInfo from '../../features/Briefing/CustomerState';
import * as ingredients from '../../features/Briefing/IngredientsState';

const rootReducers = {
  briefing: briefing.reducers,
  customerInfo: customerInfo.reducers,
  countryMarket: countryMarket.reducers,
  ingredients: ingredients.reducers,
  taxonomies: taxonomies.reducers,
};

export default rootReducers;
